module.exports = __webpack_public_path__ + "fonts/NeutraTextBookAlt.28062760.otf";